export const SAVED_REPORTS_KEYS = {
  PRINT_MONTHLY_SCHEDULE: 'print-monthly-schedule',
  PRINT_AVAILABLE_SCHEDULE: 'print-available-schedule',
  PRINT_MASTER_SCHEDULE: 'print-master-schedule',
  PRINT_STAFFING_SHEET: 'print-staffing-sheet',
};
